import { Link } from "wouter";
import { Avatar } from "../components/Avatar";
import { Header } from "../components/Header";
import { useI18n } from "../i18n";

export function NotFound({ embedded = false }: { embedded?: boolean } = {}) {
  const { d } = useI18n();
  return (
    <div className={embedded ? "" : "min-h-dvh"}>
      {!embedded && <Header />}
      <main className="shell grid min-h-[70dvh] place-items-center text-center">
        <div>
          <Avatar index={15} size={140} mood="sad" disc={false} />
          <h1 className="display mt-6 text-5xl">{d.notFound.title}</h1>
          <p className="mt-3 text-xl text-ink-2">{d.notFound.sub}</p>
          <Link href="~/" className="btn mt-8">{d.notFound.home}</Link>
        </div>
      </main>
    </div>
  );
}
